import { render, staticRenderFns } from "./AlForm.vue?vue&type=template&id=686c1644&"
import script from "./AlForm.vue?vue&type=script&lang=js&"
export * from "./AlForm.vue?vue&type=script&lang=js&"
import style0 from "./AlForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports